import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
} from "./action-types";

import {
  FetchProfileSuccess,
  FetchProfileSuccessPayload,
  FetchProfileFailure,
  FetchProfileFailurePayload,
} from "./types";

export const fetchProfileRequest = (token: string) => ({
  type: FETCH_PROFILE_REQUEST,
  payload: { token },
});

export const fetchProfileSuccess = (
  payload: FetchProfileSuccessPayload
): FetchProfileSuccess => ({
  type: FETCH_PROFILE_SUCCESS,
  payload,
});

export const fetchProfileFailure = (
  payload: FetchProfileFailurePayload
): FetchProfileFailure => ({
  type: FETCH_PROFILE_FAILURE,
  payload,
});
